// -----
// *** INTERFACE ***
// -----
export interface BrickInfo {
  id: string;
  name: string;
  fullName: string;
  type:
    | "Brick"
    | "Plate"
    | "Slope"
    | "Minifig"
    | "Bionicle"
    | "Animal"
    | "Technic";
  viaPack: boolean;
  viaSplit: boolean;
}

// -----
// *** CLASSES ***
// -----
export const defaultBrick: BrickInfo = {
  id: "0",
  name: "default brick",
  fullName: "default brick",
  type: "Brick",
  viaPack: false,
  viaSplit: false,
};

//
// Brick
//

export const brick1x1: BrickInfo = {
  id: "3005",
  name: "Brick 1x1",
  fullName: "Brick 1x1",
  type: "Brick",
  viaPack: false,
  viaSplit: false,
};

export const brick1x2: BrickInfo = {
  id: "3004",
  name: "Brick 1x2",
  fullName: "Brick 1x2",
  type: "Brick",
  viaPack: false,
  viaSplit: false,
};

export const brick1x4: BrickInfo = {
  id: "3010",
  name: "Brick 1x4",
  fullName: "Brick 1x4",
  type: "Brick",
  viaPack: false,
  viaSplit: false,
};

export const brick2x2: BrickInfo = {
  id: "3003",
  name: "Brick 2x2",
  fullName: "Brick 2x2",
  type: "Brick",
  viaPack: false,
  viaSplit: false,
};

export const brick2x4: BrickInfo = {
  id: "3001",
  name: "Brick 2x4",
  fullName: "Brick 2x4",
  type: "Brick",
  viaPack: false,
  viaSplit: false,
};

//
// Plate
//

export const plate1x1: BrickInfo = {
  id: "3024",
  name: "Plate 1x1",
  fullName: "Plate 1x1",
  type: "Plate",
  viaPack: false,
  viaSplit: true,
};

export const plate1x2: BrickInfo = {
  id: "3023",
  name: "Plate 1x2",
  fullName: "Plate 1x2",
  type: "Plate",
  viaPack: false,
  viaSplit: true,
};

export const plate1x4: BrickInfo = {
  id: "3710",
  name: "Plate 1x4",
  fullName: "Plate 1x4",
  type: "Plate",
  viaPack: false,
  viaSplit: true,
};

export const plate2x2: BrickInfo = {
  id: "3022",
  name: "Plate 2x2",
  fullName: "Plate 2x2",
  type: "Plate",
  viaPack: false,
  viaSplit: true,
};

export const plate2x4: BrickInfo = {
  id: "3020",
  name: "Plate 2x4",
  fullName: "Plate 2x4",
  type: "Plate",
  viaPack: false,
  viaSplit: true,
};

//
//
// Sloped Bricks #1
//
//

export const slope1x1: BrickInfo = {
  id: "54200",
  name: "Slope 1x1",
  fullName: "Slope 1x1",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const slope2x1: BrickInfo = {
  id: "3040",
  name: "Slope 2x1",
  fullName: "Slope 2x1",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const slope3x1: BrickInfo = {
  id: "4286",
  name: "Slope 3x1",
  fullName: "Slope 3x1",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const slope4x1: BrickInfo = {
  id: "60477",
  name: "Slope 4x1",
  fullName: "Slope 4x1",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const slope2x2: BrickInfo = {
  id: "3039",
  name: "Slope 2x2",
  fullName: "Slope 2x2",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const slope4x2: BrickInfo = {
  id: "30363",
  name: "Slope 4x2",
  fullName: "Slope 4x2",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const inverted_slope2x2: BrickInfo = {
  id: "3660",
  name: "Inverted Slope 2x2",
  fullName: "Inverted Slope 2x2",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const inverted_slope3x2: BrickInfo = {
  id: "2752",
  name: "Inverted Slope 3x2",
  fullName: "Inverted Slope 3x2",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const inverted_slope4x2_doublepins: BrickInfo = {
  id: "30390",
  name: "Inverted Slope 4x2",
  fullName: "Inverted Slope 4x2",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

export const curved_slope2x1: BrickInfo = {
  id: "6091",
  name: "Curved Slope 2x1",
  fullName: "Curved Slope 2x1",
  type: "Slope",
  viaPack: true,
  viaSplit: false,
};

//
//
// Minifig Utensils #1
//
//

export const minifig_megaphone: BrickInfo = {
  id: "4349",
  name: "Megaphone",
  fullName: "Minifig Utensil Megaphone",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_binoculars: BrickInfo = {
  id: "30162",
  name: "Binoculars",
  fullName: "Minifig Utensil Binoculars",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_jackhammer: BrickInfo = {
  id: "30228",
  name: "Jackhammer",
  fullName: "Minifig Utensil Jackhammer",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_chisel: BrickInfo = {
  id: "6246a",
  name: "Chisel",
  fullName: "Minifig Utensil Chisel",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_moviecamera: BrickInfo = {
  id: "30148",
  name: "Movie Camera",
  fullName: "Minifig Utensil Movie Camera",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_metaldetector: BrickInfo = {
  id: "93106",
  name: "Metal Detector",
  fullName: "Minifig Utensil Metal Detector",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_suitcase: BrickInfo = {
  id: "4449",
  name: "Suitcase",
  fullName: "Minifig Utensil Suitcase",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_space_binoculars: BrickInfo = {
  id: "30304",
  name: "Space Binoculars",
  fullName: "Minifig Utensil Space Binoculars",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_walkietalkie: BrickInfo = {
  id: "3962a",
  name: "Walkie Talkie",
  fullName: "Minifig Utensil Walkie Talkie",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_miniaxe: BrickInfo = {
  id: "3835",
  name: "Mini Axe",
  fullName: "Minifig Utensil Mini Axe",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

//
//
// Binoicle Pieces #1
//
//

export const bionicle_sphere_holder: BrickInfo = {
  id: "54271",
  name: "Sphere Holder",
  fullName: "Bionicle Pieces Sphere Holder",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_krana_holder: BrickInfo = {
  id: "42042",
  name: "Krana Holder",
  fullName: "Bionicle Pieces Krana Holder",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_head: BrickInfo = {
  id: "32553",
  name: "Bionicle Head",
  fullName: "Bionicle Pieces Bionicle Head",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_toa_metru_foot: BrickInfo = {
  id: "47298",
  name: "Toa Metru Foot",
  fullName: "Bionicle Pieces Toa Metru Foot",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_bohrok_windscreen: BrickInfo = {
  id: "41671",
  name: "Bohrok Windscreen",
  fullName: "Bionicle Pieces Bohrok Windscreen",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_toa_nuva_chest_armor: BrickInfo = {
  id: "43558",
  name: "Nuva Chest Armor",
  fullName: "Bionicle Pieces Toa Nuva Chest Armor",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_claw: BrickInfo = {
  id: "32506",
  name: "Bionicle Claw",
  fullName: "Bionicle Pieces Bionicle Claw",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_ball_joint: BrickInfo = {
  id: "42760",
  name: "Bionicle Ball Joint",
  fullName: "Bionicle Pieces Ball Joint",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_axle_tooth: BrickInfo = {
  id: "42074",
  name: "Bionicle Axle Tooth",
  fullName: "Bionicle Pieces Axle Tooth",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_tooth: BrickInfo = {
  id: "x346",
  name: "Bionicle Tooth",
  fullName: "Bionicle Pieces Tooth",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

//
//
// Animals #1
//
//

export const animal_horse: BrickInfo = {
  id: "4493c01pb02",
  name: "Horse",
  fullName: "Animal Horse",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_octopus: BrickInfo = {
  id: "6086",
  name: "Octopus",
  fullName: "Animal Octopus",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_dog: BrickInfo = {
  id: "48812",
  name: "Dog",
  fullName: "Animal Dog",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_dinosaur_baby: BrickInfo = {
  id: "30464",
  name: "Dinosaur Baby",
  fullName: "Animal Dinosaur Baby",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_bat: BrickInfo = {
  id: "30103",
  name: "Bat",
  fullName: "Animal Bat",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_snake: BrickInfo = {
  id: "30115",
  name: "Snake",
  fullName: "Animal Snake",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_owl: BrickInfo = {
  id: "92084",
  name: "Owl",
  fullName: "Animal Owl",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_butterfly: BrickInfo = {
  id: "80674",
  name: "Butterfly",
  fullName: "Animal Butterfly",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_crab: BrickInfo = {
  id: "33121",
  name: "Crab",
  fullName: "Animal Crab",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

export const animal_spider: BrickInfo = {
  id: "30238",
  name: "Spider",
  fullName: "Animal Spider",
  type: "Animal",
  viaPack: true,
  viaSplit: false,
};

//
//
// Minifig Utensils #2
//
//

export const minifig_katana: BrickInfo = {
  id: "30173",
  name: "Katana",
  fullName: "Minifig Utensil Katana",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_shortsword: BrickInfo = {
  id: "76764",
  name: "Shortsword",
  fullName: "Minifig Utensil Shortsword",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_telescope: BrickInfo = {
  id: "64644",
  name: "Telescope",
  fullName: "Minifig Utensil Telescope",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_oil_can: BrickInfo = {
  id: "6246f",
  name: "Oil Can",
  fullName: "Minifig Utensil Oil Can",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_drill: BrickInfo = {
  id: "55297",
  name: "Drill",
  fullName: "Minifig Utensil Drill",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_wand: BrickInfo = {
  id: "36752a",
  name: "Wand",
  fullName: "Minifig Utensil Wand",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_pulley_wand: BrickInfo = {
  id: "30229",
  name: "Pulley Wheel",
  fullName: "Minifig Utensil Pulley Wheel",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_circular_saw: BrickInfo = {
  id: "30194",
  name: "Circular Saw",
  fullName: "Minifig Utensil Circular Saw",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_saber_hilt: BrickInfo = {
  id: "64567",
  name: "Saber Hilt",
  fullName: "Minifig Utensil Saber Hilt",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_space_scanner: BrickInfo = {
  id: "30035",
  name: "Space Scanner",
  fullName: "Minifig Utensil Space Scanner",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

//
//
// Binoicle Pieces #2
//
//

export const bionicle_ruru_mask: BrickInfo = {
  id: "32567",
  name: "Ruru Mask",
  fullName: "Bionicle Pieces Ruru Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_rau_mask: BrickInfo = {
  id: "32574",
  name: "Rau Mask",
  fullName: "Bionicle Pieces Rau Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_matatu_mask: BrickInfo = {
  id: "32570",
  name: "Matatu Mask",
  fullName: "Bionicle Pieces Matatu Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_mahiki_mask: BrickInfo = {
  id: "32575",
  name: "Mahiki Mask",
  fullName: "Bionicle Pieces Mahiki Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_pakari_mask: BrickInfo = {
  id: "32566",
  name: "Pakari Mask",
  fullName: "Bionicle Pieces Pakari Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_miru_mask: BrickInfo = {
  id: "32565",
  name: "Miru Mask",
  fullName: "Bionicle Pieces Miru Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_kau_kau_mask: BrickInfo = {
  id: "32571",
  name: "KauKau Mask",
  fullName: "Bionicle Pieces KauKau Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_kakama_mask: BrickInfo = {
  id: "32568",
  name: "Kakama Mask",
  fullName: "Bionicle Pieces Kakama Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_hau_mask: BrickInfo = {
  id: "32505",
  name: "Hau Mask",
  fullName: "Bionicle Pieces Hau Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

export const bionicle_huna_mask: BrickInfo = {
  id: "32573",
  name: "Huna Mask",
  fullName: "Bionicle Pieces Huna Mask",
  type: "Bionicle",
  viaPack: true,
  viaSplit: false,
};

//
//
// Circular Bricks
//
//

export const dish_2x2_radar: BrickInfo = {
  id: "4740",
  name: "Dish 2x2 Radar",
  fullName: "Dish 2x2 Radar",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const wheel_11mm: BrickInfo = {
  id: "6014b",
  name: "Wheel 11mm",
  fullName: "Wheel 11mm",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const dish_4x4_radar: BrickInfo = {
  id: "3960",
  name: "Dish 4x4 Radar",
  fullName: "Dish 4x4 Radar",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const dish_10x10_radar: BrickInfo = {
  id: "50990b",
  name: "Dish 10x10 Radar",
  fullName: "Dish 10x10 Radar",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const barrel_2x2x2_radar: BrickInfo = {
  id: "2489",
  name: "Barrel 2x2x2 Radar",
  fullName: "Barrel 2x2x2 Radar",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const barrel_4x4x35_radar: BrickInfo = {
  id: "30139",
  name: "Barrel 4x4x3.5 Radar",
  fullName: "Barrel 4x4x3.5 Radar",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const brick_round_4x4: BrickInfo = {
  id: "6222",
  name: "Brick Round 4x4",
  fullName: "Brick Round 4x4",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const cylinder_4x4: BrickInfo = {
  id: "41531",
  name: "Cylinder 4x4",
  fullName: "Cylinder 4x4",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const cylinder_3x6: BrickInfo = {
  id: "30360",
  name: "Cylinder 3x6",
  fullName: "Cylinder 3x6",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

export const dish_6x6_webbed: BrickInfo = {
  id: "4285b",
  name: "Dish 6x6 Webbed",
  fullName: "Dish 6x6 Webbed",
  type: "Brick",
  viaPack: true,
  viaSplit: false,
};

//
//
// Minifig Hair
//
//

export const minifig_hair_male_smooth: BrickInfo = {
  id: "3901",
  name: "Male Hair Smooth",
  fullName: "Male Hair Smooth",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_hair_female_ponytail: BrickInfo = {
  id: "62696",
  name: "Female Ponytail",
  fullName: "Female Ponytail",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_hair_angular_swept: BrickInfo = {
  id: "53982",
  name: "Angular Swept Back",
  fullName: "Angular Swept Back",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_hair_angular_sideways: BrickInfo = {
  id: "53981",
  name: "Angular Swept Sideways",
  fullName: "Angular Swept Sideways",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_short_wavy: BrickInfo = {
  id: "26139",
  name: "Short Wavy",
  fullName: "Short Wavy",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_pointed_hair: BrickInfo = {
  id: "42444",
  name: "Pointed Hair",
  fullName: "Pointed Hair",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_hair_pulled_back: BrickInfo = {
  id: "30410",
  name: "Hair Pulled Back",
  fullName: "Hair Pulled Back",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_hair_tousled: BrickInfo = {
  id: "87991",
  name: "Hair Tousled",
  fullName: "Hair Tousled",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_long_hair_and_beard: BrickInfo = {
  id: "13768",
  name: "Long Hair and Beard",
  fullName: "Long Hair and Beard",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minifig_shaggy_hair_with_beard: BrickInfo = {
  id: "37784",
  name: "Shaggy Hair with Beard",
  fullName: "Shaggy Hair with Beard",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

//
//
// Techinic
//
//

export const technic_bush: BrickInfo = {
  id: "3713",
  name: "Technic Bush",
  fullName: "Technic Bush",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_axle_1l_with_pin: BrickInfo = {
  id: "3749",
  name: "Axle 1l with Pin",
  fullName: "Axle 1l with Pin",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_axle_3l_with_stop: BrickInfo = {
  id: "24316",
  name: "Axle 3l with Stop",
  fullName: "Axle 3l with Stop",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_brick_1x1_with_axle_hole: BrickInfo = {
  id: "73230",
  name: "Brick 1x1 with Axle Hole",
  fullName: "Brick 1x1 with Axle Hole",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_brick_1x4_with_hole: BrickInfo = {
  id: "3701",
  name: "Brick 1x4 with Holes",
  fullName: "Brick 1x4 with Holes",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_axle_connecter: BrickInfo = {
  id: "32174",
  name: "Axle Connector",
  fullName: "Axle Connector",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_axle_pin_connector: BrickInfo = {
  id: "32034",
  name: "Axle Pin Connector",
  fullName: "Axle Pin Connector",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_gear_24_tooth: BrickInfo = {
  id: "3648",
  name: "Gear 24 Tooth",
  fullName: "Gear 24 Tooth",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_steering_pulley: BrickInfo = {
  id: "3736",
  name: "Steering Pulley",
  fullName: "Steering Pulley",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

export const technic_throwbot_arm: BrickInfo = {
  id: "32168",
  name: "Throwbot Arm",
  fullName: "Throwbot Arm",
  type: "Technic",
  viaPack: true,
  viaSplit: false,
};

//
//
// Minifig Headgear
//
//

export const minfig_chef_hat: BrickInfo = {
  id: "3898",
  name: "Chef Hat",
  fullName: "Chef Hat",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_underwater_helmet: BrickInfo = {
  id: "30202",
  name: "Underwater Helmet",
  fullName: "Underwater Helmet",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_rebel_pilot_helmet: BrickInfo = {
  id: "x164",
  name: "Rebel Pilot Helmet",
  fullName: "Rebel Pilot Helmet",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_witch_hat: BrickInfo = {
  id: "3485",
  name: "Witch Hat",
  fullName: "Witch Hat",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_scout_trooper_helmet: BrickInfo = {
  id: "x52",
  name: "Scout Trooper Helmet",
  fullName: "Scout Trooper Helmet",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_pirate_hat: BrickInfo = {
  id: "2528",
  name: "Pirate Hat",
  fullName: "Pirate Hat",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_police_hat: BrickInfo = {
  id: "3624",
  name: "Police Hat",
  fullName: "Police Hat",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_mining_helmet: BrickInfo = {
  id: "30325",
  name: "Mining Helmet",
  fullName: "Mining Helmet",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_wide_brim_hat: BrickInfo = {
  id: "30167",
  name: "Wide Brim Hat",
  fullName: "Wide Brim Hat",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};

export const minfig_hood: BrickInfo = {
  id: "30381",
  name: "Hood",
  fullName: "Hood",
  type: "Minifig",
  viaPack: true,
  viaSplit: false,
};
